class TokenService {
    static setAccessToken(token) {
        localStorage.setItem("token", token);
        // Extract and store the original user id from the JWT on first login
        // so it persists even if we swap tokens to act as a chain-mapped user
        try {
            const ORIGINAL_KEY = "originalLoggedUserId";
            if (!localStorage.getItem(ORIGINAL_KEY) && token) {
                const decoded = JSON.parse(atob(token.split('.')[1]));
                const userId = decoded?.UserId || decoded?.userId || decoded?.id || null;
                if (userId) {
                    localStorage.setItem(ORIGINAL_KEY, String(userId));
                }
            }
            // Persist the original access token on first set so we can use it
            // for operations that should always run as the logged-in user.
            const ORIGINAL_TOKEN_KEY = "originalAccessToken";
            if (!localStorage.getItem(ORIGINAL_TOKEN_KEY) && token) {
                localStorage.setItem(ORIGINAL_TOKEN_KEY, token);
            }
        } catch (e) {
            // Token not a valid JWT or decode failed, ignore
        }
    }
    static set(key, value) {
        localStorage.setItem(key, value);
    }
    static get(key) {
        return localStorage.getItem(key);
    }
    static getAccessToken() {
        return localStorage.getItem("token");
    }
    static getOriginalAccessToken() {
        return localStorage.getItem("originalAccessToken");
    }
    static setRefreshToken(token) {
        localStorage.setItem("refreshToken", token);
    }
    static getRefreshToken() {
        return localStorage.getItem("refreshToken");
    }
    static setRoles(roles) {
        localStorage.setItem("roles", roles);
    }
    static getRoles() {
        return localStorage.getItem("roles");
    }
    static clearTokens() {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("refreshtokenExpiryTime");
        localStorage.removeItem("originalAccessToken");
    }
    static clearAll() {
        localStorage.clear();
    }
}

export default TokenService;
